import { DEVICES } from '@constants/global'
import { COLORS } from '@styles/colors'
import { text2XL } from '@styles/fonts'
import styled, { keyframes } from 'styled-components'

const grow = (width) => keyframes`
  from { width: 0; }
  to   { width: ${width}%; }
`

export const StackedBarChart = styled.div`
  display: flex;
  flex-direction: column;
`

export const StackedBarChartTitle = styled.h2`
  ${text2XL};
  color: ${COLORS.suburbHeading};
  letter-spacing: 1.6px;
  margin-bottom: 32px;

  @media ${DEVICES.mobile} {
    text-align: center;
  }
`

export const BarWrapper = styled.div`
  display: flex;
  height: 34px;
  overflow: hidden;
  border-radius: 34px;
  margin-bottom: 16px;
`

export const BarSegment = styled.div`
  width: ${({ width }) => width}%;
  background-color: ${({ color }) => color};
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 16px;
  color: white;
  animation: ${(p) => grow(p.width)} 0.5s ease-out forwards;
  padding-left: ${({ width }) => (width < 5 ? '5px' : '16px')};

  &:last-child {
    color: ${({ color }) =>
      color === COLORS.cobalt[40] ? COLORS.secondary : COLORS.white};
  }

  @media ${DEVICES.mobile} {
    font-size: 14px;
    padding-left: ${({ width }) => (width < 10 ? '5px' : '16px')};
  
    span {
      display: none;
    }
  }
`

export const Legend = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 10px;
`

export const LegendItem = styled.li`
  display: flex;
  align-items: center;
  font-size: 14px;
  color: ${COLORS.navi};
  gap: 10px;
`

export const Dot = styled.span`
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 1px solid ${({ color }) => color};
  display: inline-block;
  position: relative;

  &::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background-color: ${({ color }) => color};
  }
`
